import React from "react";
import { newLineToBr } from "../../../utilities";

interface CardProps {
  activity: server.dto.TourActivity
}

const ProductionActivityCardContent = (props: CardProps) => {
  const card = Switch(props);

  if (card == null) return null;

  return <div className="margin-left">
    {card}
  </div>;
};

const Switch = (props: CardProps) => {
  // Check out eSignActivityCardContent.tsx for the rest of the code

  if (!props.activity.content) return null;

  return <Regular content={props.activity.content} />;
};

const Regular = ({ content }: { content?: string }) => {
  return <div className="flex">
    <div style={{ width: 3 }} className="darkgray-bg"></div>
    <div className="grow1 padding-small">
      {newLineToBr(content)}
    </div>
  </div>;
};

export default ProductionActivityCardContent;